import React, {useRef} from 'react'
import {Link, Route, Routes, useLocation, useNavigate, useSearchParams} from 'react-router-dom'
import Tabbar from '../../components/Tabbar'
import Profile from '../../components/Profile'
import Search from '../../components/Search'
import '../../styles/css/Karyawan.css'
import Table from '../../components/karyawan/Table'
import searchIcon from '../../assets/icons/search-icon.svg'
import {useDispatch, useSelector} from 'react-redux'
import Sidebar from '../../components/sidebar/Sidebar'
import {useEffect} from 'react'
import {getKategori, setCurrentKategori, setIsInitial, setKategoriId} from '../../features/ketegoriSlice'
import {useState} from 'react'
import * as XLSX from 'xlsx';
import {
    getKaryawan,
    importPenilaian,
    resetTable,
    updateFieldValue,
    updateStateKaryawan
} from '../../features/karyawanSlice'
import InfoBox from '../../components/InfoBox'
import LoadingTable from '../../components/LoadingTable'
import LoadingTabbar from '../../components/LoadingTabbar'
import Skeleton from 'react-loading-skeleton'
import Button from "../../components/Button";
import {getSiswa, importSiswa} from "../../features/siswaSlice";
import {importKaryawan} from "../../features/pengaturanSlice";
import {updateStateWaliKelas} from "../../features/waliKelasSlice";
import PreviewExcelKaryawan from "../../components/karyawan/PreviewExcelKaryawan";
const GREY = '#9B9B9B'
const BORDER = '#ECEEF2'
function Karyawan() {
    const {
        listKaryawan,
        isLoading,
        statusResApi,
        messageResApi,
        isDisplayMessage,
        search
    } = useSelector(state => state.karyawan)
    const {listKategori, kategoriId, loadingKategori, currentKategori,} = useSelector(state => state.kategori)
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const inputFileRef = useRef(null)
    const [isKategoriUpdated, setIsKategoriUpdated] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams()
    const [showModal, setShowModal] = useState(false)
    const [file, setFile] = useState(null)
    let kategoriAll = [
        {id: 'all', kategori: 'Semua Karyawan'},
    ]

    // update state biar kosong dan dapeting getKategori
    useEffect(() => {
        dispatch(resetTable())
        dispatch(getKategori());
    }, [dispatch]);

    useEffect(() => {
        const currentPath = location.pathname;

        // setelah listKategori berhasil di dapatkan lansung di arhkan di index yang ke 0
        if (currentPath === '/karyawan/' && listKategori.length > 0) {
            const defaultPath = `/karyawan/${listKategori[0]?.kategori}`;
            navigate(defaultPath);
        }

        // ketika ngetik paginate lansung di url nya
        if (searchParams.get('paginate')) {
            dispatch(updateStateKaryawan({name: 'currentPage', value: parseInt(searchParams.get('paginate'))}));
        }
    }, [location.pathname, listKategori, navigate, searchParams]);

    const [sheets, setSheets] = useState([])

    // jalan ketika search hardcore ketika lansung di url tanpa event listener
    useEffect(() => {

        if (searchParams.get('search') && !loadingKategori) {
            dispatch(updateStateKaryawan({name: 'search', value: searchParams.get('search')}));
            dispatch(getKaryawan({search: searchParams.get('search')}))
        }
    }, [loadingKategori])


    // kalau listkategori nya akan set 2 dispatch itu bacse on initialOption
    useEffect(() => {
        if (listKategori.length > 0) {
            const initialOption = listKategori.find(option =>
                option.kategori === decodeURIComponent(location.pathname.split('/').pop())
            );
            if (initialOption) {
                dispatch(setCurrentKategori(initialOption.kategori))
                dispatch(setKategoriId(initialOption.id))
            }
        }
    }, [location.pathname, loadingKategori])


    // set kategori update doang kalau kalau ngga loading sama current categori kalau ada nanti di update
    useEffect(() => {
        if (!loadingKategori && currentKategori) {
            setIsKategoriUpdated(true)
            dispatch(setIsInitial(false))
        }
    }, [loadingKategori, currentKategori]);


    // kalau udah ada categori nya dan iskategoriupdate true dan ada id dan search params nya ngga ada akan ambil data getkaryawan
    // sama update field categoryId
    useEffect(() => {
        if (isKategoriUpdated && kategoriId && !searchParams.get('search')) {
            dispatch(getKaryawan({kategori_id: kategoriId}));
            dispatch(updateFieldValue({field: 'kategoriId', value: kategoriId}));
            setIsKategoriUpdated(false);
        }
    }, [kategoriId, isKategoriUpdated]);


    // ketika karyawan pindah halaman dari /karyawan -> /siswa akan di reset jadi value 1 current page nay
    useEffect(() => {
        dispatch(updateStateKaryawan({name: 'currentPage', value: 1}))
    }, [location.pathname.split('/').pop()]);


    // handle search
    function handleSearch() {
        dispatch(getKaryawan({search}))
        dispatch(updateStateKaryawan({name: 'currentPage', value: 1}))
        setSearchParams({
            'search': search
        })
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') {
            handleSearch();
        }
    }

    function handleChange(e) {
        e.preventDefault();
        setShowModal(true)
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
        }


        let fileObj = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (evt) => {
            const workbook = XLSX.read(evt.target.result, { type: 'array' });
            const parsedSheets = workbook.SheetNames.map((name) => {
                const ws = workbook.Sheets[name];
                const data = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' });
                const headerRow = data[0] || [];
                const cols = headerRow.map((h) => String(h));
                const rows = data.slice(1);
                return { name, cols, rows };
            });
            setSheets(parsedSheets);
        };
        reader.readAsArrayBuffer(fileObj);
    }

    function handleImport() {
        dispatch(importPenilaian(file))
            .then((res) => {
                if (res.meta.requestStatus === "fulfilled") {
                    setShowModal(false)
                    dispatch(getKaryawan({}))
                    inputFileRef.current.value = '';
                }
            })
    }

    return (
        <div className='wrapper-karyawan'>
            <Sidebar/>
            <div className='karyawan'>
                <InfoBox
                    message={messageResApi}
                    status={statusResApi}
                    isDisplay={isDisplayMessage}
                    setIsDisplay={updateStateKaryawan}
                    stateName='isDisplayMessage'
                />





                <div className='search-and-profile'>

                    <div className={'wrap-search'}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 10, padding: '0 16px', height: 48, width: 300, marginRight: 16 }}>
                            <span style={{ color: GREY, fontSize: 14 }}>🔍</span>
                            <input
                                type="text"
                                placeholder="Cari guru"
                                value={search}
                                onKeyDown={handleKeyDown}
                                onChange={(e) => dispatch(updateStateKaryawan({ name: 'search', value: e.target.value }))}
                                style={{ border: 'none', outline: 'none', fontSize: 14, color: '#A6A6A6', flex: 1 }}
                            />
                        </div>



                        <button
                            className='btn-search'
                            style={{ background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 10, padding: '0 16px', height: 48, width: 48 }}
                            onClick={handleSearch}
                        >
                            <img src={searchIcon} alt="" />
                        </button>
                    </div>
                    <Profile />
                </div>


      <div className={'kalender'}>

          {showModal &&  <div className='bg-modal wrapper-preview'>
              <div className='modal'>
                  <PreviewExcelKaryawan
                      sheets={sheets}
                  />

                  <div className='container-btn'>
                      <div>
                          <Button
                              text={'Batal'}
                              onClick={() => {
                                  setShowModal(false);
                                  if (inputFileRef.current) {
                                      inputFileRef.current.value = '';
                                  }
                              }}
                              className='button-cancel'
                          />

                          <Button
                              text={'Konfirmasi'}
                              onClick={handleImport}
                          />
                      </div>
                  </div>
              </div>
          </div>
          }
      </div>

                <div className='title-btn'>
                    <h1>Karyawan</h1>
                    <div style={{display: 'flex', flexDirection: 'row', gap: '10px'}}>

                        <div className='right-header'>
                            <Button
                                style={{
                                    width: "150px",
                                    height: "45px"
                                }}
                                text={'Import Penilaian'}
                                onClick={() => inputFileRef.current.click()}
                            />
                            <input
                                style={{display: 'none'}}
                                ref={inputFileRef}
                                type="file"
                                onChange={handleChange}
                                accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
                            />
                        </div>
                        <Link to='/karyawan/add'>+ Add New</Link>

                    </div>

                </div>

                {!loadingKategori
                    ? <div className='tabbar-filter'>
                        <Tabbar
                            options={[...kategoriAll, ...listKategori]}
                            setKategoriId={setKategoriId}
                            setCurrentKategori={setCurrentKategori}
                            searchParams={''}
                            setKeterangan={updateStateKaryawan}
                            path='/karyawan'
                            loading={loadingKategori}
                        />

                        <div className='filter-angka'>
                            {isLoading
                                ? <Skeleton
                                    width={100}
                                    height={25}
                                />
                                : <p>{listKaryawan.length + ' Guru'}</p>
                            }
                        </div>
                    </div>

                    : <div className='wrapper__skeleton'>
                        <LoadingTabbar amount={5} loadingFilter={isLoading}/>
                    </div>
                }

                {(loadingKategori || isLoading) ?
                    <LoadingTable size={'large'}/>
                    : <Table/>
                }
            </div>
        </div>
    )
}

export default Karyawan